import type { SVGProps } from 'react';

export const FeedbackMessageSent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    height="18px"
    role="img"
    viewBox="0 0 20.9 18"
    width="20.9px"
    x="0px"
    xmlSpace="preserve"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    y="0px"
    {...props}
  >
    <title>{'feedback message sent'}</title>
    <g>
      <path
        d="M20.6,0.7c0-0.1-0.1-0.1-0.1-0.1c-0.1-0.1-0.3-0.3-0.4-0.3c-0.1-0.1-0.3-0.1-0.4-0.1
          C19.5,0,19.2,0,19,0H6.5C5.7,0,5.2,0.3,5,0.6C4.7,0.9,4.6,1.2,4.6,1.7v5.1v0.7c0.3-0.1,0.6-0.1,1-0.1c0,0,0,0,0,0V6.7v-5
          c0-0.1,0-0.2,0-0.3L10.5,6L8.3,7.5L7.6,7.9c0.3,0.1,0.6,0.3,0.8,0.5L9.1,8l2.1-1.4L11.5,7c0.4,0.3,0.8,0.5,1.2,0.5
          c0.1,0,0.3,0,0.4-0.1C13.5,7.3,13.7,7.2,14,7c0,0,0,0,0.1-0.1c0,0,0,0,0,0l0.3-0.3l5.6,3.7C19.8,10.7,19.7,11,19,11H11h-0.8
          c0.1,0.3,0.1,0.6,0.2,1h0.7H19c1.1,0,1.8-0.8,1.8-1.8c0,0,0,0,0,0c0,0,0,0,0,0l0-8.5C20.8,1.3,20.8,0.9,20.6,0.7z M14,5.7l-0.5,0.5
          c0,0-0.1,0.1-0.1,0.1c-0.1,0.1-0.3,0.2-0.4,0.2c-0.2,0-0.4,0.1-0.8-0.3l-0.6-0.5c0,0,0,0,0,0L6.3,1c0.1,0,12.9,0,13,0L14,5.7z
          M19.9,1.7v7.6L14.9,6l4.9-4.5C19.9,1.6,19.9,1.6,19.9,1.7z"
        fill={props.fill}
      />
    </g>
    <g>
      <polygon
        fill={props.fill}
        points="5,14.6 2.3,11.9 2.7,11.5 5,13.8 8.5,10.3 8.9,10.7"
      />
      <path
        d="M5,14.7L5,14.7l-2.8-2.8l0.5-0.5l0.1,0.1L5,13.7l3.5-3.5L9,10.7l-0.1,0.1L5,14.7z"
        fill={props.fill}
      />
    </g>
    <path
      d="M5.6,18C2.5,18,0,15.5,0,12.4s2.5-5.6,5.6-5.6s5.6,2.5,5.6,5.6S8.7,18,5.6,18z M5.6,7.5
        c-2.7,0-4.9,2.2-4.9,4.9c0,2.7,2.2,4.9,4.9,4.9s4.9-2.2,4.9-4.9C10.4,9.7,8.3,7.5,5.6,7.5z"
      fill={props.fill}
    />
  </svg>
);
